import { render, staticRenderFns } from "./MewTextArea.vue?vue&type=template&id=a4ee15c6"
import script from "./MewTextArea.vue?vue&type=script&lang=js"
export * from "./MewTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports